// extracted by mini-css-extract-plugin
export default {"cover":"_0JLts","thumbContainer":"h4UvM","thumbWrapper":"Wv1ro"};